import { getPaginatedSchema } from '@/common/utilities.ts'
import { z } from 'zod'

// get Program Roles
const RolesResponse = z.object({
  id: z.number().nullable(),
  name: z.string().nullable(),
  code: z.string().nullable(),
  description: z.string().nullable(),
})

export type RolesResponse = z.infer<typeof RolesResponse>
export const PaginatedRolesSchema = getPaginatedSchema(RolesResponse)

export type PaginatedRoles = z.infer<typeof PaginatedRolesSchema>

export const PermissionsSchema = z.object({
  create: z.number(),
  read: z.number(),
  edit: z.number(),
  delete: z.number(),
})

export const RolePermissionsSchema = z.object({
  resource_id: z.number(),
  resource_name: z.string(),
  permissions: PermissionsSchema,
})

export const CreateRoleSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string(),
  description: z.string().nullable(),
})

export type CreateRole = {
  data: z.infer<typeof CreateRoleSchema> | null
  error: string | null
}

export const RolePermissionListSchema = z.array(RolePermissionsSchema) // Expect an array directly from the API
export type RolePermissionList = z.infer<typeof RolePermissionListSchema>

export type RolePermissionsDetail = z.infer<typeof RolePermissionsSchema>

export type UpdateRolePermissionObj = {
  resource_id: number
  create: boolean
  read: boolean
  edit: boolean
  delete: boolean
}

export type UpdateRolePermissionsReq = {
  permissions: Array<UpdateRolePermissionObj>
}

export const UpdateRolePermissionsResSchema = z.object({
  message: z.string(),
})

export type UpdateRolePermissionsRes = z.infer<
  typeof UpdateRolePermissionsResSchema
>
export type UpdateRoleReq = {
  description: string
}

export const UpdateRoleResSchema = z.object({
  data: z.string(),
})

export type UpdateRoleRes = z.infer<typeof UpdateRoleResSchema>
